import { Outlet } from 'react-router-dom'

import { View } from '@/components/layouts/View'

export function Root() {
  return (
    <View className="relative">
      <Outlet />
    </View>
  )
}
